export enum DeviceStatus {
  outDated = 'OutDated',
  notMonitored = 'NotMonitored',
  online = 'Online',
  offline = 'Offline',
  malfunction = 'Malfunction',
  batteryCritical = 'BatteryCritical',
  batteryLow = 'BatteryLow',
}
